import { Injectable } from '@angular/core';
import { CTVMock } from '../DataStore/Mock/ctvmock';
import { CTVModel } from '../Models/ctv-model';
import { StepModel } from '../Models/step-model';
import { StepServiceService } from './step-service.service';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';
import { log } from 'util';

@Injectable({
  providedIn: 'root'
})
export class CTVService {

  constructor(
    private stepService: StepServiceService,
    private rest: RestService
  ) { }
  public findByObjectId(id: string): CTVModel {
    return CTVMock.findByObjectId(id);

  }

  public findById(id: number): CTVModel {
    return CTVMock.findById(id);
  }

  public getItems(): CTVModel[] {
    return CTVMock.getItems();
  }
  /* 
    public getItemsByStep(model:StepModel): CTVModel[]{
      let output  =[];
      
      let ctvs = model.commandSteps;
  
      for(let i = 0; i < ctvs.length; i++){
        output.push(this.findByObjectId(ctvs[i]));
      }
  
      return output;
    } */

  public getItemsByStep(model_id: string): Observable<CTVModel[]> {
    return this.rest.get('commandSteps', model_id);
  }
  public getItemsByStepdb2(model_id: string): Observable<CTVModel[]> {
    return this.rest.get('commandStepsdb2', model_id);
  }
  public addNew(scenariostepid, ctv): Observable<any> {
    var dataCtv = this.commandStep(ctv);
    // var dataCtv=ctv;
    var data = {
      scenariostep: { _id: scenariostepid },
      commandSteps: dataCtv
    };
    return this.rest.put('addCommandSteps', data);
  }
  public addNewdb2(scenariostepid, ctv): Observable<any> {
    var dataCtv = this.commandStep(ctv);
    // var dataCtv=ctv;
    var data = {
      scenariostep: { _id: scenariostepid },
      commandSteps: dataCtv
    };
    return this.rest.put('addCommandStepsdb2', data);
  }

  commandStep(ctv) {
    var al = [];
    for (var x = 0; x < ctv.length; x++)
      al.push({
        _id: ctv[x]._id,
        command: ctv[x].command._id ,
        target: ctv[x].target == null ? null : ctv[x].target._id ,
        target2: ctv[x].target2 == null ? null :
          ctv[x].target2._id == null ?  ctv[x].target2.$oid :
            ctv[x].target2._id.$oid == null ?ctv[x].target2._id:ctv[x].target2._id.$oid,
        value: ctv[x].value == null ? "" : ctv[x].value,
        value2: ctv[x].value2 == null ? "" : ctv[x].value2,
        deleted: ctv[x].deleted,
        errors: ctv[x].errors,
        warnings: ctv[x].warnings,
        seq_no: x,
        type: ctv[x].type,
        value1SecureMode: ctv[x].value1SecureMode,
        value2SecureMode: ctv[x].value2SecureMode,
        active: ctv[x].active,
        english_description: ctv[x].english_description || ctv[x].englishDescription || ""
      });
    return al;
  }

  delete(ctv) {
    let model = {
      commandStep: {
        _id: ctv._id
      }
    }
    return this.rest.post("deleteCommandStep", model)
  }
}